import { Button } from "../../atoms";
import { Dialog, DialogHeader, DialogBody, DialogFooter } from "../../atoms";

export interface ConfirmDeleteModalProps {
    /** 表示するか */
    isOpen: boolean;
    /** キャンセル時のコールバック */
    onCancel: () => void;
    /** 削除確定時のコールバック */
    onConfirm: () => void;
    /** 削除処理中フラグ */
    isDeleting?: boolean;
    /** タイトル（省略時は「確認」） */
    title?: string;
    /** 本文メッセージ（省略時は「このデータを削除します。よろしいですか？」） */
    message?: string;
}

/**
 * ConfirmDeleteModal - 削除確認モーダル
 *
 * フォーム系ページ左サイドバーの削除ボタン押下時に表示する共通確認ダイアログ。
 */
export const ConfirmDeleteModal = ({
    isOpen,
    onCancel,
    onConfirm,
    isDeleting = false,
    title = "確認",
    message = "このデータを削除します。よろしいですか？",
}: ConfirmDeleteModalProps) => {
    if (!isOpen) return null;

    return (
        <Dialog onClose={isDeleting ? undefined : onCancel} className="w-[420px]">
            <DialogHeader
                title={title}
                onClose={isDeleting ? undefined : onCancel}
                className="border-b-0"
            />
            <DialogBody>
                <p className="text-sm text-gray-700">{message}</p>
            </DialogBody>
            <DialogFooter className="border-t-0">
                <Button variant="outline" size="md" onClick={onCancel} disabled={isDeleting}>
                    キャンセル
                </Button>
                <Button variant="danger" size="md" onClick={onConfirm} disabled={isDeleting}>
                    {isDeleting ? "削除中..." : "削除する"}
                </Button>
            </DialogFooter>
        </Dialog>
    );
};

export default ConfirmDeleteModal;
